import { create } from 'zustand'

interface PlanDialogState {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

export const usePlanDialogStore = create<PlanDialogState>((set) => ({
  open: false,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}))
